/* eslint-disable */
import { Zap, Play, Gauge, Clock, Cpu, Globe, Box, Sparkles, Sliders, TrendingUp, ShieldCheck, BarChart2, FileText, Plus } from "lucide-react";
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { WorkspaceContext } from "../context/WorkspaceContext";

import { API_BASE } from "../config/apiConfig";

const customCss = `
  .pt-container {
    background-color: #f8fafc;
    color: #0f172a;
    font-family: 'Outfit', 'Inter', -apple-system, sans-serif;
    min-height: 100vh;
    padding: 24px;
  }
  .pt-glass-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 4px 16px rgba(124, 58, 237, 0.03);
    transition: all 0.25s ease;
  }
  .pt-glass-card:hover {
    border-color: rgba(124, 58, 237, 0.25);
    box-shadow: 0 6px 24px rgba(124, 58, 237, 0.08);
  }
  .pt-input {
    background: #ffffff;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    color: #0f172a;
    padding: 10px 14px;
    outline: none;
    font-size: 14px;
    width: 100%;
    transition: border-color 0.2s, box-shadow 0.2s;
  }
  .pt-input:focus {
    border-color: #FD6101;
    box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.12);
  }
  .pt-radio-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: #f1f5f9;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    color: #475569;
    transition: all 0.2s ease;
  }
  .pt-radio-btn.active {
    background: #FD6101;
    color: #ffffff;
    border-color: #FD6101;
    box-shadow: 0 2px 8px rgba(124, 58, 237, 0.25);
  }
  .pt-btn-primary {
    background: #FD6101;
    border: none;
    color: #ffffff;
    border-radius: 10px;
    font-weight: 600;
    padding: 12px 24px;
    cursor: pointer;
    font-size: 15px;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    box-shadow: 0 4px 14px rgba(253, 97, 1, 0.3);
    transition: all 0.2s ease;
  }
  .pt-btn-primary:hover {
    background: #e05300;
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(253, 97, 1, 0.4);
  }
  .pt-tabs-container {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    padding-bottom: 12px;
    margin-bottom: 24px;
    width: 100%;
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 transparent;
  }
  .pt-tabs-container::-webkit-scrollbar {
    height: 6px;
  }
  .pt-tabs-container::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
  }
  .pt-tabs-container::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
  }
  .pt-tabs-container::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
  .pt-nav-tab {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 9px 16px;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
    color: #64748b;
    cursor: pointer;
    white-space: nowrap;
    flex-shrink: 0;
    transition: all 0.2s ease;
    border: 1px solid #e2e8f0;
    background: #ffffff;
    user-select: none;
  }
  .pt-nav-tab:hover {
    color: #FD6101;
    border-color: #FD6101;
    background: #fff7ed;
  }
  .pt-nav-tab.active {
    background: #FD6101;
    color: #ffffff;
    border-color: #FD6101;
    box-shadow: 0 2px 8px rgba(253, 97, 1, 0.25);
  }
  .pt-nav-tab.active svg {
    color: #ffffff;
  }
  .pt-score-gauge {
    width: 140px;
    height: 140px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    box-shadow: inset 0 2px 6px rgba(0,0,0,0.1);
  }
  .pt-badge-good {
    background: #dcfce7;
    color: #15803d;
    border: 1px solid #bbf7d0;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 700;
  }
  .pt-badge-warn {
    background: #fef9c3;
    color: #a16207;
    border: 1px solid #fef08a;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 700;
  }
  .pt-badge-poor {
    background: #fee2e2;
    color: #b91c1c;
    border: 1px solid #fca5a5;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 700;
  }
  .pt-modal-overlay {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(15, 23, 42, 0.55);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    padding: 20px;
  }
`;

export default function PerformanceTesting() {
  const { activeRepoProject } = useContext(WorkspaceContext);
  const currentProject = activeRepoProject || "Pegatto";

  // Navigation State
  const [activeTab, setActiveTab] = useState("audit"); // audit, dashboard, cwv, loading, runtime, network, resources, opportunities, device, baseline, budgets, ai, history, report

  // Audit Form State
  const [form, setForm] = useState({
    name: "Pegatto Homepage Performance",
    project: currentProject,
    target_url: "https://example.com",
    environment: "Staging",
    device: "Desktop",
    network_profile: "Simulated 4G",
    browser: "Chrome",
    audit_types: [
      "Lighthouse Performance",
      "Core Web Vitals",
      "Network Analysis",
      "Resource Analysis",
      "Runtime Analysis"
    ],
    runs_count: 3
  });

  const [showAdvanced, setShowAdvanced] = useState(false);
  const [advancedConfig, setAdvancedConfig] = useState({
    cpu_throttling: "4x Slowdown",
    bypass_cache: true,
    custom_headers: "",
    cookies: ""
  });

  // Audit Execution & Results State
  const [isRunning, setIsRunning] = useState(false);
  const [progressStep, setProgressStep] = useState(0);
  const [progressText, setProgressText] = useState("");

  // Audit Result Data
  const [auditResult, setAuditResult] = useState(null);
  const [historyList, setHistoryList] = useState([]);
  const [selectedOpportunity, setSelectedOpportunity] = useState(null);

  // AI Chat Copilot State
  const [aiQuestion, setAiQuestion] = useState("");
  const [aiAnswer, setAiAnswer] = useState(null);
  const [isAiLoading, setIsAiLoading] = useState(false);

  useEffect(() => {
    fetchHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentProject]);

  const fetchHistory = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/performance/history?project=${currentProject}`);
      if (res.data && res.data.audits) {
        setHistoryList(res.data.audits);
      }
    } catch (err) {
      console.error("Failed to fetch performance history:", err);
    }
  };

  const handleToggleAuditType = (type) => {
    setForm(prev => {
      const current = [...prev.audit_types];
      if (current.includes(type)) {
        return { ...prev, audit_types: current.filter(t => t !== type) };
      } else {
        return { ...prev, audit_types: [...current, type] };
      }
    });
  };

  const handleStartTest = async () => {
    if (!form.target_url) {
      alert("Please specify a valid Target URL.");
      return;
    }

    setIsRunning(true);
    setProgressStep(1);
    setProgressText("Validating Target URL & Enforcing Enterprise SSRF Security Policies...");

    const t1 = setTimeout(() => {
      setProgressStep(2);
      setProgressText("Launching Headless Chromium Browser Engine with Device Emulation...");
    }, 1200);

    const t2 = setTimeout(() => {
      setProgressStep(3);
      setProgressText(`Executing Google Lighthouse Engine Audits (${form.runs_count} iterations)...`);
    }, 3500);

    const t3 = setTimeout(() => {
      setProgressStep(4);
      setProgressText("Processing Authentic Core Web Vitals, Network Traces & Diagnostic Audits...");
    }, 12000);

    try {
      const res = await axios.post(`${API_BASE}/api/performance/run`, {
        ...form,
        project: currentProject,
        advanced_config: advancedConfig
      });

      if (res.data && res.data.success) {
        setAuditResult(res.data);
        setActiveTab("dashboard");
        fetchHistory();
      } else {
        const errType = res.data?.status || "ERROR";
        const errMsg = res.data?.error || "Unknown execution error";
        alert(`[${errType}] Failed to execute real performance test: ${errMsg}`);
      }
    } catch (err) {
      console.error("Performance run error:", err);
      const errMsg = err.response?.data?.error || err.message || "Backend connection error";
      alert(`Error starting real performance audit: ${errMsg}`);
    } finally {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      setIsRunning(false);
      setProgressStep(0);
    }
  };

  const handleAskAi = async (customPrompt) => {
    const q = customPrompt || aiQuestion;
    if (!q) return;

    setIsAiLoading(true);
    try {
      const res = await axios.post(`${API_BASE}/api/performance/ai-analyze`, {
        question: q,
        audit_data: auditResult
      });
      if (res.data && res.data.answer) {
        setAiAnswer(res.data);
      }
    } catch (err) {
      console.error("AI Analysis error:", err);
    } finally {
      setIsAiLoading(false);
    }
  };

  // Helper for score color
  const getScoreColor = (score) => {
    if (score >= 90) return { main: "#16a34a", bg: "#dcfce7", border: "#86efac", label: "Excellent" };
    if (score >= 75) return { main: "#ca8a04", bg: "#fef9c3", border: "#fde047", label: "Good" };
    if (score >= 50) return { main: "#ea580c", bg: "#ffedd5", border: "#fdba74", label: "Needs Improvement" };
    return { main: "#dc2626", bg: "#fee2e2", border: "#fca5a5", label: "Poor" };
  };

  const currentScoreInfo = auditResult ? getScoreColor(auditResult.score) : getScoreColor(92);

  return (
    <div className="pt-container">
      <style>{customCss}</style>

      {/* Header Banner */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Zap size={26} color="#FD6101" />
            <h1 style={{ margin: 0, fontSize: "24px", fontWeight: 800, color: "#0f172a", letterSpacing: "-0.5px" }}>
              Performance Testing & Lighthouse Audit Engine
            </h1>
            <span style={{ background: "#FD6101", color: "#fff", padding: "3px 10px", borderRadius: "12px", fontSize: "11px", fontWeight: 700 }}>
              SINGLE-PAGE & WEB APP PERFORMANCE
            </span>
          </div>
          <p style={{ margin: "4px 0 0 0", color: "#64748b", fontSize: "14px" }}>
            Authoritative Google Lighthouse metrics, Core Web Vitals (LCP, INP, CLS), network traces, main thread work, and AI score optimization.
          </p>
        </div>

        {auditResult && (
          <div style={{ display: "flex", gap: "10px" }}>
            <button 
              className="pt-btn-primary" 
              onClick={() => setActiveTab("audit")}
              style={{ padding: "8px 16px", fontSize: "13px" }}
            >
              <Plus size={14} /> Create New Audit
            </button>
          </div>
        )}
      </div>

      {/* Tab Navigation Menu */}
      <div className="pt-tabs-container">
        <div className={`pt-nav-tab ${activeTab === "audit" ? "active" : ""}`} onClick={() => setActiveTab("audit")}>
          <Play size={14} /> Create Performance Audit
        </div>
        <div className={`pt-nav-tab ${activeTab === "dashboard" ? "active" : ""}`} onClick={() => setActiveTab("dashboard")}>
          <Gauge size={14} /> Lighthouse & Score
        </div>
        <div className={`pt-nav-tab ${activeTab === "cwv" ? "active" : ""}`} onClick={() => setActiveTab("cwv")}>
          <Zap size={14} /> Core Web Vitals
        </div>
        <div className={`pt-nav-tab ${activeTab === "loading" ? "active" : ""}`} onClick={() => setActiveTab("loading")}>
          <Clock size={14} /> Loading Metrics
        </div>
        <div className={`pt-nav-tab ${activeTab === "runtime" ? "active" : ""}`} onClick={() => setActiveTab("runtime")}>
          <Cpu size={14} /> Runtime & Main Thread
        </div>
        <div className={`pt-nav-tab ${activeTab === "network" ? "active" : ""}`} onClick={() => setActiveTab("network")}>
          <Globe size={14} /> Network Performance
        </div>
        <div className={`pt-nav-tab ${activeTab === "resources" ? "active" : ""}`} onClick={() => setActiveTab("resources")}>
          <Box size={14} /> Resource Optimization
        </div>
        <div className={`pt-nav-tab ${activeTab === "opportunities" ? "active" : ""}`} onClick={() => setActiveTab("opportunities")}>
          <Sparkles size={14} /> Opportunities
        </div>
        <div className={`pt-nav-tab ${activeTab === "device" ? "active" : ""}`} onClick={() => setActiveTab("device")}>
          <Sliders size={14} /> Device & Network Matrix
        </div>
        <div className={`pt-nav-tab ${activeTab === "baseline" ? "active" : ""}`} onClick={() => setActiveTab("baseline")}>
          <TrendingUp size={14} /> Baseline & Comparison
        </div>
        <div className={`pt-nav-tab ${activeTab === "budgets" ? "active" : ""}`} onClick={() => setActiveTab("budgets")}>
          <ShieldCheck size={14} /> Performance Budgets
        </div>
        <div className={`pt-nav-tab ${activeTab === "ai" ? "active" : ""}`} onClick={() => setActiveTab("ai")}>
          <Sparkles size={14} /> AI Improvement Plan
        </div>
        <div className={`pt-nav-tab ${activeTab === "history" ? "active" : ""}`} onClick={() => setActiveTab("history")}>
          <BarChart2 size={14} /> Score History
        </div>
        <div className={`pt-nav-tab ${activeTab === "report" ? "active" : ""}`} onClick={() => setActiveTab("report")}>
          <FileText size={14} /> Executive Report
        </div>
      </div>

      {/* Audit Progress Running Banner */}
      {isRunning && (
        <div className="pt-glass-card" style={{ padding: "24px", marginBottom: "24px", background: "#002247", color: "#fff" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <div style={{ width: "40px", height: "40px", borderRadius: "50%", border: "4px solid #a855f7", borderTopColor: "transparent", animation: "spin 1s linear infinite" }}></div>
            <style>{`@keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
            <div>
              <div style={{ fontSize: "16px", fontWeight: 700, color: "#fff7ed" }}>
                Running Performance Audit ({progressStep}/4)...
              </div>
              <div style={{ fontSize: "14px", color: "#d8b4fe", marginTop: "4px" }}>
                {progressText}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ------------------ TAB 1: CREATE PERFORMANCE AUDIT FORM ------------------ */}
      {activeTab === "audit" && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 340px", gap: "24px" }}>
          <div className="pt-glass-card" style={{ padding: "28px" }}>
            <h2 style={{ margin: "0 0 20px 0", fontSize: "18px", fontWeight: 700, color: "#0f172a", borderBottom: "1px solid #f1f5f9", paddingBottom: "12px" }}>
              🛠️ Configure Performance Audit
            </h2>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px", marginBottom: "20px" }}>
              <div>
                <label style={{ fontSize: "13px", fontWeight: 600, color: "#475569", display: "block", marginBottom: "6px" }}>
                  Test Name
                </label>
                <input
                  type="text"
                  className="pt-input"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  placeholder="e.g. Pegatto Homepage Performance Audit"
                />
              </div>

              <div>
                <label style={{ fontSize: "13px", fontWeight: 600, color: "#475569", display: "block", marginBottom: "6px" }}>
                  Application / Project
                </label>
                <select
                  className="pt-input"
                  value={form.project}
                  onChange={(e) => setForm({ ...form, project: e.target.value })}
                >
                  <option value="Pegatto">Pegatto</option>
                  <option value="CRM Farm">CRM Farm</option>
                  <option value="Qintra">Qintra Platform</option>
                  <option value={currentProject}>{currentProject}</option>
                </select>
              </div>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label style={{ fontSize: "13px", fontWeight: 600, color: "#475569", display: "block", marginBottom: "6px" }}>
                Target URL
              </label>
              <input
                type="text"
                className="pt-input"
                value={form.target_url}
                onChange={(e) => setForm({ ...form, target_url: e.target.value })}
                placeholder="https://example.com"
              />
            </div>

            {/* Radio Selectors Grid */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px", marginBottom: "20px" }}>
              <div>
                <label style={{ fontSize: "13px", fontWeight: 600, color: "#475569", display: "block", marginBottom: "8px" }}>
                  Environment
                </label>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  {["Development", "QA", "Staging", "Production"].map((env) => (
                    <div
                      key={env}
                      className={`pt-radio-btn ${form.environment === env ? "active" : ""}`}
                      onClick={() => setForm({ ...form, environment: env })}
                    >
                      <span>{form.environment === env ? "●" : "○"}</span>
                      <span>{env}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <label style={{ fontSize: "13px", fontWeight: 600, color: "#475569", display: "block", marginBottom: "8px" }}>
                  Device Profile
                </label>
                <div style={{ display: "flex", gap: "8px" }}>
                  {["Desktop", "Mobile"].map((dev) => (
                    <div
                      key={dev}
                      className={`pt-radio-btn ${form.device === dev ? "active" : ""}`}
                      onClick={() => setForm({ ...form, device: dev })}
                    >
                      <span>{dev === "Desktop" ? "🖥️" : "📱"}</span>
                      <span>{form.device === dev ? "●" : "○"}</span>
                      <span>{dev}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px", marginBottom: "20px" }}>
              <div>
                <label style={{ fontSize: "13px", fontWeight: 600, color: "#475569", display: "block", marginBottom: "8px" }}>
                  Network Profile
                </label>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  {["Simulated 4G", "Slow 4G", "Fast 4G", "Wi-Fi"].map((net) => (
                    <div
                      key={net}
                      className={`pt-radio-btn ${form.network_profile === net ? "active" : ""}`}
                      onClick={() => setForm({ ...form, network_profile: net })}
                    >
                      <span>{form.network_profile === net ? "●" : "○"}</span>
                      <span>{net}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <label style={{ fontSize: "13px", fontWeight: 600, color: "#475569", display: "block", marginBottom: "8px" }}>
                  Browser Engine
                </label>
                <select
                  className="pt-input"
                  value={form.browser}
                  onChange={(e) => setForm({ ...form, browser: e.target.value })}
                >
                  <option value="Chrome">Google Chrome (Headless Chromium)</option>
                  <option value="Firefox">Mozilla Firefox</option>
                  <option value="Edge">Microsoft Edge</option>
                  <option value="Safari">Safari (WebKit)</option>
                </select>
              </div>
            </div>

            {/* Audit Checkboxes */}
            <div style={{ marginBottom: "24px" }}>
              <label style={{ fontSize: "13px", fontWeight: 600, color: "#475569", display: "block", marginBottom: "10px" }}>
                Audit Modules
              </label>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                {[
                  "Lighthouse Performance",
                  "Core Web Vitals",
                  "Network Analysis",
                  "Resource Analysis",
                  "Runtime Analysis"
                ].map((mod) => (
                  <label key={mod} style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "13px", color: "#334155", cursor: "pointer", background: "#f8fafc", padding: "8px 12px", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
                    <input
                      type="checkbox"
                      checked={form.audit_types.includes(mod)}
                      onChange={() => handleToggleAuditType(mod)}
                      style={{ accentColor: "#FD6101", width: "16px", height: "16px" }}
                    />
                    <span style={{ fontWeight: 500 }}>{mod}</span>
                  </label>
                ))}
              </div>
            </div>

            {/* Number of Runs */}
            <div style={{ marginBottom: "24px" }}>
              <label style={{ fontSize: "13px", fontWeight: 600, color: "#475569", display: "block", marginBottom: "6px" }}>
                Number of Repeat Runs (Statistical Precision)
              </label>
              <select
                className="pt-input"
                style={{ width: "200px" }}
                value={form.runs_count}
                onChange={(e) => setForm({ ...form, runs_count: parseInt(e.target.value, 10) })}
              >
                <option value={1}>1 Run (Quick Inspection)</option>
                <option value={3}>3 Runs (Recommended Median)</option>
                <option value={5}>5 Runs (High Precision Statistical)</option>
              </select>
            </div>

            {/* Advanced Configuration Collapsible */}
            <div style={{ marginBottom: "28px" }}>
              <button
                type="button"
                onClick={() => setShowAdvanced(!showAdvanced)}
                style={{ background: "none", border: "none", color: "#FD6101", fontSize: "13px", fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", gap: "6px", padding: 0 }}
              >
                <span>{showAdvanced ? "▼" : "▶"}</span>
                <span>[ Advanced Configuration ]</span>
              </button>

              {showAdvanced && (
                <div style={{ marginTop: "12px", padding: "16px", background: "#f8fafc", borderRadius: "10px", border: "1px solid #e2e8f0", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                  <div>
                    <label style={{ fontSize: "12px", color: "#64748b", display: "block", marginBottom: "4px" }}>CPU Throttling</label>
                    <select
                      className="pt-input"
                      value={advancedConfig.cpu_throttling}
                      onChange={(e) => setAdvancedConfig({ ...advancedConfig, cpu_throttling: e.target.value })}
                    >
                      <option value="No Throttling">No Throttling (1x)</option>
                      <option value="4x Slowdown">4x Slowdown (Mobile Standard)</option>
                      <option value="6x Slowdown">6x Slowdown (Low-end Mobile)</option>
                    </select>
                  </div>

                  <div>
                    <label style={{ fontSize: "12px", color: "#64748b", display: "block", marginBottom: "4px" }}>Cache Policy</label>
                    <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "13px", marginTop: "10px" }}>
                      <input
                        type="checkbox"
                        checked={advancedConfig.bypass_cache}
                        onChange={(e) => setAdvancedConfig({ ...advancedConfig, bypass_cache: e.target.checked })}
                      />
                      <span>Bypass browser cache (Clean load)</span>
                    </label>
                  </div>
                </div>
              )}
            </div>

            {/* Start Button */}
            <div>
              <button className="pt-btn-primary" onClick={handleStartTest} disabled={isRunning}>
                <span>🚀</span>
                <span>{isRunning ? "Running Performance Test..." : "Start Performance Test"}</span>
              </button>
            </div>
          </div>

          {/* Quick Engine Info Card */}
          <div>
            <div className="pt-glass-card" style={{ padding: "20px", marginBottom: "16px", background: "#fff7ed", border: "1px solid #fed7aa" }}>
              <div style={{ fontSize: "14px", fontWeight: 700, color: "#6b21a8", marginBottom: "8px" }}>
                🎯 Authoritative Lighthouse Engine
              </div>
              <p style={{ fontSize: "12px", color: "#581c87", lineHeight: "1.5", margin: 0 }}>
                Qintra runs official Google Lighthouse v10 weightings: FCP (10%), Speed Index (10%), LCP (25%), Total Blocking Time (30%), and CLS (25%). Legacy TTI/FID are omitted in favor of INP.
              </p>
            </div>

            <div className="pt-glass-card" style={{ padding: "20px" }}>
              <h3 style={{ margin: "0 0 12px 0", fontSize: "14px", fontWeight: 700, color: "#0f172a" }}>
                📜 Audit Preset Archetypes
              </h3>
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <div style={{ padding: "10px", background: "#f8fafc", borderRadius: "8px", border: "1px solid #e2e8f0", cursor: "pointer" }} onClick={() => setForm({ ...form, name: "Pegatto Desktop Core Audit", device: "Desktop", network_profile: "Simulated 4G" })}>
                  <div style={{ fontSize: "13px", fontWeight: 600, color: "#334155" }}>🚀 Desktop Core Audit</div>
                  <div style={{ fontSize: "11px", color: "#64748b" }}>Unthrottled desktop browser render check</div>
                </div>
                <div style={{ padding: "10px", background: "#f8fafc", borderRadius: "8px", border: "1px solid #e2e8f0", cursor: "pointer" }} onClick={() => setForm({ ...form, name: "Pegatto Mobile 4G Audit", device: "Mobile", network_profile: "Slow 4G" })}>
                  <div style={{ fontSize: "13px", fontWeight: 600, color: "#334155" }}>📱 Mobile Slow 4G Audit</div>
                  <div style={{ fontSize: "11px", color: "#64748b" }}>4x CPU throttling under cellular network</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ------------------ TAB 2: LIGHTHOUSE SCORE DASHBOARD ------------------ */}
      {(activeTab === "dashboard" || (!auditResult && activeTab !== "audit" && activeTab !== "history")) && (
        <div>
          {/* Top Score Gauge Card */}
          <div className="pt-glass-card" style={{ padding: "32px", marginBottom: "24px", background: "#ffffff", textAlign: "center" }}>
            <div style={{ fontSize: "13px", fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "1px", marginBottom: "16px" }}>
              LIGHTHOUSE PERFORMANCE SCORE
            </div>

            <div className="pt-score-gauge" style={{ background: currentScoreInfo.bg, border: `4px solid ${currentScoreInfo.main}` }}>
              <div style={{ fontSize: "44px", fontWeight: 900, color: currentScoreInfo.main, lineHeight: 1 }}>
                {auditResult ? auditResult.score : 92}
              </div>
              <div style={{ fontSize: "12px", fontWeight: 700, color: currentScoreInfo.main, marginTop: "2px" }}>
                {currentScoreInfo.label}
              </div>
            </div>

            {/* Score Comparison vs Previous Run */}
            <div style={{ display: "flex", justifyContent: "center", gap: "32px", marginTop: "24px", borderTop: "1px solid #f1f5f9", paddingTop: "16px" }}>
              <div>
                <div style={{ fontSize: "12px", color: "#64748b" }}>Previous Run</div>
                <div style={{ fontSize: "18px", fontWeight: 700, color: "#334155" }}>
                  {auditResult ? auditResult.previous_score : 86}
                </div>
              </div>
              <div>
                <div style={{ fontSize: "12px", color: "#64748b" }}>Current Score</div>
                <div style={{ fontSize: "18px", fontWeight: 700, color: currentScoreInfo.main }}>
                  {auditResult ? auditResult.score : 92}
                </div>
              </div>
              <div>
                <div style={{ fontSize: "12px", color: "#64748b" }}>Score Change</div>
                <div style={{ fontSize: "18px", fontWeight: 700, color: (auditResult?.score_change >= 0) ? "#16a34a" : "#dc2626" }}>
                  {(auditResult ? auditResult.score_change : 6) >= 0 ? `+${auditResult?.score_change || 6}` : auditResult?.score_change}
                </div>
              </div>
            </div>
          </div>

          {/* Core Web Vitals & Loading Summary Grid */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px", marginBottom: "24px" }}>
            {/* Core Web Vitals */}
            <div className="pt-glass-card" style={{ padding: "24px" }}>
              <h3 style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: 700, color: "#0f172a", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span>⚡ Core Web Vitals</span>
                <span className="pt-badge-good">PASSING ALL CRITERIA</span>
              </h3>

              <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", background: "#f8fafc", borderRadius: "8px" }}>
                  <div>
                    <div style={{ fontSize: "13px", fontWeight: 700, color: "#0f172a" }}>LCP (Largest Contentful Paint)</div>
                    <div style={{ fontSize: "11px", color: "#64748b" }}>Target: &lt; 2.5s</div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <span style={{ fontSize: "16px", fontWeight: 800, color: "#0f172a", marginRight: "10px" }}>
                      {auditResult ? auditResult.metrics.lcp : "1.8s"}
                    </span>
                    <span className="pt-badge-good">GOOD</span>
                  </div>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", background: "#f8fafc", borderRadius: "8px" }}>
                  <div>
                    <div style={{ fontSize: "13px", fontWeight: 700, color: "#0f172a" }}>INP (Interaction to Next Paint)</div>
                    <div style={{ fontSize: "11px", color: "#64748b" }}>Target: &lt; 200ms</div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <span style={{ fontSize: "16px", fontWeight: 800, color: "#0f172a", marginRight: "10px" }}>
                      {auditResult ? auditResult.metrics.inp : "145ms"}
                    </span>
                    <span className="pt-badge-good">GOOD</span>
                  </div>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", background: "#f8fafc", borderRadius: "8px" }}>
                  <div>
                    <div style={{ fontSize: "13px", fontWeight: 700, color: "#0f172a" }}>CLS (Cumulative Layout Shift)</div>
                    <div style={{ fontSize: "11px", color: "#64748b" }}>Target: &lt; 0.10</div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <span style={{ fontSize: "16px", fontWeight: 800, color: "#0f172a", marginRight: "10px" }}>
                      {auditResult ? auditResult.metrics.cls : "0.04"}
                    </span>
                    <span className="pt-badge-good">GOOD</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Loading Performance */}
            <div className="pt-glass-card" style={{ padding: "24px" }}>
              <h3 style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: 700, color: "#0f172a" }}>
                ⏱️ Loading Performance Breakdown
              </h3>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                  <div style={{ fontSize: "12px", color: "#64748b" }}>First Contentful Paint (FCP)</div>
                  <div style={{ fontSize: "18px", fontWeight: 800, color: "#0f172a", marginTop: "4px" }}>
                    {auditResult ? auditResult.metrics.fcp : "1.2s"}
                  </div>
                </div>
                <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                  <div style={{ fontSize: "12px", color: "#64748b" }}>Speed Index</div>
                  <div style={{ fontSize: "18px", fontWeight: 800, color: "#0f172a", marginTop: "4px" }}>
                    {auditResult ? auditResult.metrics.speed_index : "2.1s"}
                  </div>
                </div>
                <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                  <div style={{ fontSize: "12px", color: "#64748b" }}>Time to First Byte (TTFB)</div>
                  <div style={{ fontSize: "18px", fontWeight: 800, color: "#0f172a", marginTop: "4px" }}>
                    {auditResult ? auditResult.metrics.ttfb : "420ms"}
                  </div>
                </div>
                <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                  <div style={{ fontSize: "12px", color: "#64748b" }}>Total Load Time</div>
                  <div style={{ fontSize: "18px", fontWeight: 800, color: "#0f172a", marginTop: "4px" }}>
                    {auditResult ? auditResult.metrics.total_load_time : "2.4s"}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Section 4: Why is my score X? */}
          <div className="pt-glass-card" style={{ padding: "24px", marginBottom: "24px" }}>
            <h3 style={{ margin: "0 0 8px 0", fontSize: "16px", fontWeight: 700, color: "#0f172a" }}>
              🔍 Why is my score {auditResult ? auditResult.score : 68}?
            </h3>
            <p style={{ margin: "0 0 16px 0", fontSize: "13px", color: "#64748b" }}>
              Top performance factors directly reducing your Lighthouse score weight:
            </p>

            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              {(auditResult?.top_factors || [
                { metric: "Largest Contentful Paint (LCP)", value: "4.2s", target: "< 2.5s", severity: "CRITICAL", impact: "High", reason: "Hero image load delay" },
                { metric: "Total Blocking Time (TBT)", value: "420ms", target: "< 200ms", severity: "WARNING", impact: "Medium", reason: "Main thread script execution" },
                { metric: "Speed Index", value: "4.8s", target: "< 3.4s", severity: "WARNING", impact: "Medium", reason: "Render blocking CSS stylesheets" }
              ]).map((factor, idx) => (
                <div key={idx} style={{ padding: "14px", background: "#f8fafc", borderRadius: "10px", borderLeft: `4px solid ${factor.severity === "CRITICAL" ? "#dc2626" : "#ea580c"}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <span style={{ fontSize: "14px" }}>{factor.severity === "CRITICAL" ? "🔴" : "🟠"}</span>
                      <span style={{ fontSize: "14px", fontWeight: 700, color: "#0f172a" }}>{factor.metric}</span>
                    </div>
                    <div style={{ fontSize: "12px", color: "#64748b", marginTop: "4px" }}>
                      Actual: <strong>{factor.value}</strong> (Target: {factor.target})
                    </div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div style={{ fontSize: "11px", color: "#64748b" }}>Estimated improvement</div>
                    <span className={factor.impact === "High" ? "pt-badge-poor" : "pt-badge-warn"}>
                      {factor.impact}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* ------------------ TAB 3: CORE WEB VITALS DETAILED DIAGNOSTICS ------------------ */}
      {activeTab === "cwv" && (
        <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
          <div className="pt-glass-card" style={{ padding: "24px" }}>
            <h2 style={{ margin: "0 0 16px 0", fontSize: "18px", fontWeight: 700, color: "#0f172a" }}>
              ⚡ Core Web Vitals Field & Lab Analysis
            </h2>

            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
              <thead>
                <tr style={{ background: "#f8fafc", textAlign: "left", color: "#475569" }}>
                  <th style={{ padding: "12px" }}>Metric</th>
                  <th style={{ padding: "12px" }}>Value</th>
                  <th style={{ padding: "12px" }}>Status</th>
                  <th style={{ padding: "12px" }}>Standard Target</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ borderBottom: "1px solid #f1f5f9" }}>
                  <td style={{ padding: "12px", fontWeight: 600 }}>LCP (Largest Contentful Paint)</td>
                  <td style={{ padding: "12px", fontWeight: 700 }}>{auditResult?.metrics.lcp || "1.8s"}</td>
                  <td style={{ padding: "12px" }}><span className="pt-badge-good">🟢 Good</span></td>
                  <td style={{ padding: "12px", color: "#64748b" }}>&lt; 2.5s</td>
                </tr>
                <tr style={{ borderBottom: "1px solid #f1f5f9" }}>
                  <td style={{ padding: "12px", fontWeight: 600 }}>INP (Interaction to Next Paint)</td>
                  <td style={{ padding: "12px", fontWeight: 700 }}>{auditResult?.metrics.inp || "N/A (Lab Audit)"}</td>
                  <td style={{ padding: "12px" }}>
                    {auditResult?.metrics.inp ? (
                      <span className="pt-badge-good">🟢 Good</span>
                    ) : (
                      <span className="pt-badge-warn" style={{ background: "#f1f5f9", color: "#64748b", borderColor: "#cbd5e1" }}>⚪ N/A (Lab Audit)</span>
                    )}
                  </td>
                  <td style={{ padding: "12px", color: "#64748b" }}>&lt; 200ms</td>
                </tr>
                <tr>
                  <td style={{ padding: "12px", fontWeight: 600 }}>CLS (Cumulative Layout Shift)</td>
                  <td style={{ padding: "12px", fontWeight: 700 }}>{auditResult?.metrics.cls || "0.04"}</td>
                  <td style={{ padding: "12px" }}><span className="pt-badge-good">🟢 Good</span></td>
                  <td style={{ padding: "12px", color: "#64748b" }}>&lt; 0.10</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* LCP Diagnostics Component Breakdown */}
          <div className="pt-glass-card" style={{ padding: "24px" }}>
            <h3 style={{ margin: "0 0 12px 0", fontSize: "16px", fontWeight: 700, color: "#0f172a" }}>
              🖼️ Authentic LCP Element & Timing Breakdown
            </h3>
            <p style={{ fontSize: "13px", color: "#64748b", margin: "0 0 20px 0" }}>
              LCP Element: <code>{auditResult?.lcp_breakdown?.lcp_element || "Primary LCP Element"}</code>
            </p>

            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <div>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: "4px" }}>
                  <span style={{ fontWeight: 600 }}>Server Response Time (TTFB)</span>
                  <span>{auditResult?.lcp_breakdown?.ttfb || "420ms"}</span>
                </div>
                <div style={{ width: "100%", background: "#e2e8f0", height: "12px", borderRadius: "6px", overflow: "hidden" }}>
                  <div style={{ width: "25%", background: "#0284c7", height: "100%" }}></div>
                </div>
              </div>

              <div>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: "4px" }}>
                  <span style={{ fontWeight: 600 }}>Element Resource Load Delay</span>
                  <span>{auditResult?.lcp_breakdown?.load_delay || "0.2s"}</span>
                </div>
                <div style={{ width: "100%", background: "#e2e8f0", height: "12px", borderRadius: "6px", overflow: "hidden" }}>
                  <div style={{ width: "20%", background: "#ca8a04", height: "100%" }}></div>
                </div>
              </div>

              <div>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: "4px" }}>
                  <span style={{ fontWeight: 600 }}>Resource Load Duration</span>
                  <span>{auditResult?.lcp_breakdown?.load_time || "1.1s"}</span>
                </div>
                <div style={{ width: "100%", background: "#e2e8f0", height: "12px", borderRadius: "6px", overflow: "hidden" }}>
                  <div style={{ width: "45%", background: "#FD6101", height: "100%" }}></div>
                </div>
              </div>

              <div>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: "4px" }}>
                  <span style={{ fontWeight: 600 }}>Element Render Delay</span>
                  <span>{auditResult?.lcp_breakdown?.render_delay || "180ms"}</span>
                </div>
                <div style={{ width: "100%", background: "#e2e8f0", height: "12px", borderRadius: "6px", overflow: "hidden" }}>
                  <div style={{ width: "15%", background: "#16a34a", height: "100%" }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ------------------ TAB 4: LOADING METRICS ------------------ */}
      {activeTab === "loading" && (
        <div className="pt-glass-card" style={{ padding: "24px" }}>
          <h2 style={{ margin: "0 0 16px 0", fontSize: "18px", fontWeight: 700, color: "#0f172a" }}>
            ⏱️ Full Loading Performance Metrics
          </h2>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "16px" }}>
            <div style={{ padding: "16px", background: "#f8fafc", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
              <div style={{ fontSize: "12px", color: "#64748b" }}>First Contentful Paint (FCP)</div>
              <div style={{ fontSize: "22px", fontWeight: 800, color: "#FD6101", marginTop: "4px" }}>
                {auditResult?.metrics.fcp || "1.2s"}
              </div>
            </div>

            <div style={{ padding: "16px", background: "#f8fafc", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
              <div style={{ fontSize: "12px", color: "#64748b" }}>Largest Contentful Paint (LCP)</div>
              <div style={{ fontSize: "22px", fontWeight: 800, color: "#FD6101", marginTop: "4px" }}>
                {auditResult?.metrics.lcp || "1.8s"}
              </div>
            </div>

            <div style={{ padding: "16px", background: "#f8fafc", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
              <div style={{ fontSize: "12px", color: "#64748b" }}>Speed Index</div>
              <div style={{ fontSize: "22px", fontWeight: 800, color: "#FD6101", marginTop: "4px" }}>
                {auditResult?.metrics.speed_index || "2.1s"}
              </div>
            </div>

            <div style={{ padding: "16px", background: "#f8fafc", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
              <div style={{ fontSize: "12px", color: "#64748b" }}>Time to First Byte (TTFB)</div>
              <div style={{ fontSize: "22px", fontWeight: 800, color: "#FD6101", marginTop: "4px" }}>
                {auditResult?.metrics.ttfb || "420ms"}
              </div>
            </div>

            <div style={{ padding: "16px", background: "#f8fafc", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
              <div style={{ fontSize: "12px", color: "#64748b" }}>Total Load Time [Calculated]</div>
              <div style={{ fontSize: "22px", fontWeight: 800, color: "#FD6101", marginTop: "4px" }}>
                {auditResult?.metrics.total_load_time || "2.4s"}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ------------------ TAB 5: RUNTIME & MAIN THREAD WORK ------------------ */}
      {activeTab === "runtime" && (
        <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
          <div className="pt-glass-card" style={{ padding: "24px" }}>
            <h2 style={{ margin: "0 0 16px 0", fontSize: "18px", fontWeight: 700, color: "#0f172a" }}>
              🧠 Main Thread Work Breakdown
            </h2>

            <div style={{ fontSize: "28px", fontWeight: 900, color: "#FD6101", marginBottom: "16px" }}>
              Total Main Thread Work: {auditResult?.main_thread.total_work || "2.8s"}
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: "16px" }}>
              <div style={{ padding: "14px", background: "#f8fafc", borderRadius: "8px" }}>
                <div style={{ fontSize: "12px", color: "#64748b" }}>JavaScript Execution</div>
                <div style={{ fontSize: "18px", fontWeight: 700, color: "#0f172a", marginTop: "4px" }}>
                  {auditResult?.main_thread.js_execution || "1.7s"}
                </div>
              </div>

              <div style={{ padding: "14px", background: "#f8fafc", borderRadius: "8px" }}>
                <div style={{ fontSize: "12px", color: "#64748b" }}>Style & Layout</div>
                <div style={{ fontSize: "18px", fontWeight: 700, color: "#0f172a", marginTop: "4px" }}>
                  {auditResult?.main_thread.style_layout || "420ms"}
                </div>
              </div>

              <div style={{ padding: "14px", background: "#f8fafc", borderRadius: "8px" }}>
                <div style={{ fontSize: "12px", color: "#64748b" }}>Rendering</div>
                <div style={{ fontSize: "18px", fontWeight: 700, color: "#0f172a", marginTop: "4px" }}>
                  {auditResult?.main_thread.rendering || "310ms"}
                </div>
              </div>

              <div style={{ padding: "14px", background: "#f8fafc", borderRadius: "8px" }}>
                <div style={{ fontSize: "12px", color: "#64748b" }}>Other Task Work</div>
                <div style={{ fontSize: "18px", fontWeight: 700, color: "#0f172a", marginTop: "4px" }}>
                  {auditResult?.main_thread.other || "370ms"}
                </div>
              </div>
            </div>
          </div>

          {/* Long Tasks Table */}
          <div className="pt-glass-card" style={{ padding: "24px" }}>
            <h3 style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: 700, color: "#0f172a" }}>
              ⏱️ Main Thread Long Tasks (&gt;50ms)
            </h3>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
              <thead>
                <tr style={{ background: "#f8fafc", textAlign: "left", color: "#475569" }}>
                  <th style={{ padding: "10px" }}>Task Description</th>
                  <th style={{ padding: "10px" }}>Duration</th>
                  <th style={{ padding: "10px" }}>Location</th>
                </tr>
              </thead>
              <tbody>
                {(auditResult?.main_thread.long_tasks || [
                  { task: "Evaluate main.chunk.js script", duration: "340ms", location: "main.js:142" },
                  { task: "Recalculate Style & Layout Grid", duration: "180ms", location: "app.css:88" }
                ]).map((t, idx) => (
                  <tr key={idx} style={{ borderBottom: "1px solid #f1f5f9" }}>
                    <td style={{ padding: "10px", fontWeight: 600 }}>{t.task}</td>
                    <td style={{ padding: "10px", color: "#dc2626", fontWeight: 700 }}>{t.duration}</td>
                    <td style={{ padding: "10px", color: "#64748b", fontFamily: "monospace" }}>{t.location}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ------------------ TAB 6: NETWORK PERFORMANCE ------------------ */}
      {activeTab === "network" && (
        <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
          <div className="pt-glass-card" style={{ padding: "24px" }}>
            <h2 style={{ margin: "0 0 16px 0", fontSize: "18px", fontWeight: 700, color: "#0f172a" }}>
              🌐 Network Performance & Payload Summary
            </h2>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr", gap: "12px", marginBottom: "20px" }}>
              <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                <div style={{ fontSize: "11px", color: "#64748b" }}>Total Requests</div>
                <div style={{ fontSize: "18px", fontWeight: 800, color: "#0f172a" }}>{auditResult?.network_performance.total_requests || 87}</div>
              </div>
              <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                <div style={{ fontSize: "11px", color: "#64748b" }}>Total Transfer</div>
                <div style={{ fontSize: "18px", fontWeight: 800, color: "#0f172a" }}>{auditResult?.network_performance.total_transfer || "3.8 MB"}</div>
              </div>
              <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                <div style={{ fontSize: "11px", color: "#64748b" }}>HTML Payload</div>
                <div style={{ fontSize: "18px", fontWeight: 800, color: "#0f172a" }}>{auditResult?.network_performance.html || "82 KB"}</div>
              </div>
              <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                <div style={{ fontSize: "11px", color: "#64748b" }}>JS Payload</div>
                <div style={{ fontSize: "18px", fontWeight: 800, color: "#0f172a" }}>{auditResult?.network_performance.js || "1.9 MB"}</div>
              </div>
              <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                <div style={{ fontSize: "11px", color: "#64748b" }}>CSS Payload</div>
                <div style={{ fontSize: "18px", fontWeight: 800, color: "#0f172a" }}>{auditResult?.network_performance.css || "480 KB"}</div>
              </div>
              <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px" }}>
                <div style={{ fontSize: "11px", color: "#64748b" }}>Images Payload</div>
                <div style={{ fontSize: "18px", fontWeight: 800, color: "#0f172a" }}>{auditResult?.network_performance.images || "1.2 MB"}</div>
              </div>
            </div>

            {/* Slowest Network Endpoint Requests */}
            <h3 style={{ margin: "16px 0 12px 0", fontSize: "15px", fontWeight: 700, color: "#0f172a" }}>
              🐢 Slowest Network Endpoint Requests
            </h3>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
              <thead>
                <tr style={{ background: "#f8fafc", textAlign: "left", color: "#475569" }}>
                  <th style={{ padding: "10px" }}>URL Path</th>
                  <th style={{ padding: "10px" }}>Duration</th>
                  <th style={{ padding: "10px" }}>Status</th>
                  <th style={{ padding: "10px" }}>Size</th>
                  <th style={{ padding: "10px" }}>Type</th>
                </tr>
              </thead>
              <tbody>
                {(auditResult?.network_performance.slowest_requests || []).map((req, idx) => (
                  <tr key={idx} style={{ borderBottom: "1px solid #f1f5f9" }}>
                    <td style={{ padding: "10px", fontFamily: "monospace", color: "#334155", maxWidth: "300px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {req.url}
                    </td>
                    <td style={{ padding: "10px", fontWeight: 700, color: req.duration !== "N/A" ? "#FD6101" : "#64748b" }}>
                      {req.duration}
                    </td>
                    <td style={{ padding: "10px" }}>
                      <span style={{ background: req.status === "200" ? "#dcfce7" : "#fee2e2", color: req.status === "200" ? "#16a34a" : "#dc2626", padding: "2px 6px", borderRadius: "4px", fontSize: "12px", fontWeight: 700 }}>
                        {req.status}
                      </span>
                    </td>
                    <td style={{ padding: "10px" }}>{req.size}</td>
                    <td style={{ padding: "10px", color: "#64748b" }}>{req.type}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Network Problems list */}
          <div className="pt-glass-card" style={{ padding: "24px" }}>
            <h3 style={{ margin: "0 0 12px 0", fontSize: "15px", fontWeight: 700, color: "#0f172a" }}>
              ⚠️ Detected Network Problems
            </h3>
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              {(auditResult?.network_performance.problems || [
                "🔴 4 requests > 1 second duration",
                "🟠 7 resources are uncompressed",
                "🟠 3 images are oversized",
                "🟡 12 cache opportunities detected"
              ]).map((prob, idx) => (
                <div key={idx} style={{ padding: "10px 14px", background: "#f8fafc", borderRadius: "8px", fontSize: "13px", fontWeight: 500, color: "#334155" }}>
                  {prob}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* ------------------ TAB 7: RESOURCE OPTIMIZATION ------------------ */}
      {activeTab === "resources" && (
        <div className="pt-glass-card" style={{ padding: "24px" }}>
          <h2 style={{ margin: "0 0 16px 0", fontSize: "18px", fontWeight: 700, color: "#0f172a" }}>
            📦 Resource Allocation & Optimization Breakdown
          </h2>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "20px" }}>
            <div style={{ padding: "16px", background: "#f8fafc", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
              <div style={{ fontSize: "14px", fontWeight: 700, color: "#0f172a", marginBottom: "8px" }}>📜 JavaScript Resources</div>
              <div style={{ fontSize: "13px", color: "#475569" }}>Total Transfer: <strong>{auditResult?.resource_analysis.javascript.total || "2.1 MB"}</strong></div>
              <div style={{ fontSize: "13px", color: "#ea580c", marginTop: "4px" }}>Unused JS Bytes: <strong>{auditResult?.resource_analysis.javascript.unused || "900 KB"}</strong></div>
              <div style={{ fontSize: "12px", color: "#dc2626", marginTop: "8px", fontWeight: 600 }}>{auditResult?.resource_analysis.javascript.warning}</div>
            </div>

            <div style={{ padding: "16px", background: "#f8fafc", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
              <div style={{ fontSize: "14px", fontWeight: 700, color: "#0f172a", marginBottom: "8px" }}>🖼️ Image Optimization</div>
              <div style={{ fontSize: "13px", color: "#475569" }}>Total Image Weight: <strong>{auditResult?.resource_analysis.images.total || "1.4 MB"}</strong></div>
              <div style={{ fontSize: "13px", color: "#ca8a04", marginTop: "4px" }}>Missing WebP/AVIF: <strong>{auditResult?.resource_analysis.images.missing_modern_format} images</strong></div>
            </div>

            <div style={{ padding: "16px", background: "#f8fafc", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
              <div style={{ fontSize: "14px", fontWeight: 700, color: "#0f172a", marginBottom: "8px" }}>🎨 CSS Stylesheets</div>
              <div style={{ fontSize: "13px", color: "#475569" }}>Total CSS Weight: <strong>{auditResult?.resource_analysis.css.total || "540 KB"}</strong></div>
              <div style={{ fontSize: "13px", color: "#ca8a04", marginTop: "4px" }}>Unused CSS Rules: <strong>{auditResult?.resource_analysis.css.unused}</strong></div>
            </div>
          </div>
        </div>
      )}

      {/* ------------------ TAB 8: PERFORMANCE OPPORTUNITIES ------------------ */}
      {activeTab === "opportunities" && (
        <div className="pt-glass-card" style={{ padding: "24px" }}>
          <h2 style={{ margin: "0 0 16px 0", fontSize: "18px", fontWeight: 700, color: "#0f172a" }}>
            🎯 Real Google Lighthouse Audit Opportunities
          </h2>

          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {(auditResult?.opportunities || []).map((opp) => (
              <div key={opp.id} style={{ padding: "16px", background: "#f8fafc", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ fontSize: "15px", fontWeight: 700, color: "#0f172a" }}>
                    {opp.title}
                  </div>
                  <span className={opp.severity === "CRITICAL" ? "pt-badge-poor" : "pt-badge-warn"}>
                    Savings: {opp.savings} ({opp.severity})
                  </span>
                </div>
                <p style={{ margin: "8px 0 12px 0", fontSize: "13px", color: "#475569" }}>
                  {opp.problem}
                </p>
                {opp.affected && opp.affected.length > 0 && (
                  <div style={{ fontSize: "12px", color: "#64748b", fontFamily: "monospace", background: "#ffffff", padding: "8px", borderRadius: "6px", border: "1px solid #cbd5e1" }}>
                    Impacted: {opp.affected.join(", ")}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ------------------ TAB 9: DEVICE & NETWORK MATRIX ------------------ */}
      {activeTab === "device" && (
        <div className="pt-glass-card" style={{ padding: "24px" }}>
          <h2 style={{ margin: "0 0 16px 0", fontSize: "18px", fontWeight: 700, color: "#0f172a" }}>
            📱 Device & Network Performance Matrix
          </h2>

          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
            <thead>
              <tr style={{ background: "#f8fafc", textAlign: "left", color: "#475569" }}>
                <th style={{ padding: "12px" }}>Metric</th>
                <th style={{ padding: "12px", textTransform: "uppercase" }}>Desktop</th>
                <th style={{ padding: "12px", textTransform: "uppercase" }}>Mobile</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ borderBottom: "1px solid #f1f5f9" }}>
                <td style={{ padding: "12px", fontWeight: 700 }}>Performance Score</td>
                <td style={{ padding: "12px", color: "#16a34a", fontWeight: 800 }}>{auditResult?.device_matrix?.desktop?.score ?? "Not Audited"}</td>
                <td style={{ padding: "12px", color: "#ea580c", fontWeight: 800 }}>{auditResult?.device_matrix?.mobile?.score ?? "Not Audited"}</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #f1f5f9" }}>
                <td style={{ padding: "12px", fontWeight: 600 }}>LCP (Largest Contentful Paint)</td>
                <td style={{ padding: "12px" }}>{auditResult?.device_matrix?.desktop?.lcp || "N/A"}</td>
                <td style={{ padding: "12px" }}>{auditResult?.device_matrix?.mobile?.lcp || "N/A"}</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #f1f5f9" }}>
                <td style={{ padding: "12px", fontWeight: 600 }}>INP (Interaction to Next Paint)</td>
                <td style={{ padding: "12px" }}>{auditResult?.device_matrix?.desktop?.inp || "N/A (Lab)"}</td>
                <td style={{ padding: "12px" }}>{auditResult?.device_matrix?.mobile?.inp || "N/A (Lab)"}</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #f1f5f9" }}>
                <td style={{ padding: "12px", fontWeight: 600 }}>CLS (Cumulative Layout Shift)</td>
                <td style={{ padding: "12px" }}>{auditResult?.device_matrix?.desktop?.cls || "N/A"}</td>
                <td style={{ padding: "12px" }}>{auditResult?.device_matrix?.mobile?.cls || "N/A"}</td>
              </tr>
              <tr>
                <td style={{ padding: "12px", fontWeight: 600 }}>FCP (First Contentful Paint)</td>
                <td style={{ padding: "12px" }}>{auditResult?.device_matrix?.desktop?.fcp || "N/A"}</td>
                <td style={{ padding: "12px" }}>{auditResult?.device_matrix?.mobile?.fcp || "N/A"}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* ------------------ TAB 10: BASELINE & COMPARISON ------------------ */}
      {activeTab === "baseline" && (
        <div className="pt-glass-card" style={{ padding: "24px" }}>
          <h2 style={{ margin: "0 0 16px 0", fontSize: "18px", fontWeight: 700, color: "#0f172a" }}>
            📈 Baseline Comparison & Regression Detection
          </h2>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px", marginBottom: "20px" }}>
            <div style={{ padding: "16px", background: "#f8fafc", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
              <div style={{ fontSize: "12px", color: "#64748b" }}>Previous Version Baseline Score</div>
              <div style={{ fontSize: "24px", fontWeight: 800, color: "#0f172a", marginTop: "4px" }}>
                {auditResult?.baseline_comparison?.score || 90}
              </div>
            </div>

            <div style={{ padding: "16px", background: "#f8fafc", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
              <div style={{ fontSize: "12px", color: "#64748b" }}>Regression Status</div>
              <div style={{ fontSize: "24px", fontWeight: 800, color: auditResult?.baseline_comparison?.regression_detected ? "#dc2626" : "#16a34a", marginTop: "4px" }}>
                {auditResult?.baseline_comparison?.regression_detected ? "🔴 Regression Detected" : "🟢 No Regression"}
              </div>
            </div>
          </div>

          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
            <thead>
              <tr style={{ background: "#f8fafc", textAlign: "left", color: "#475569" }}>
                <th style={{ padding: "10px" }}>Metric</th>
                <th style={{ padding: "10px" }}>Before Baseline</th>
                <th style={{ padding: "10px" }}>After Current</th>
                <th style={{ padding: "10px" }}>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ borderBottom: "1px solid #f1f5f9" }}>
                <td style={{ padding: "10px", fontWeight: 600 }}>LCP</td>
                <td style={{ padding: "10px" }}>{auditResult?.baseline_comparison.lcp || "1.9s"}</td>
                <td style={{ padding: "10px", fontWeight: 700 }}>{auditResult?.metrics.lcp || "1.8s"}</td>
                <td style={{ padding: "10px" }}><span className="pt-badge-good">🟢 Improved</span></td>
              </tr>
              <tr style={{ borderBottom: "1px solid #f1f5f9" }}>
                <td style={{ padding: "10px", fontWeight: 600 }}>INP</td>
                <td style={{ padding: "10px" }}>{auditResult?.baseline_comparison.inp || "120ms"}</td>
                <td style={{ padding: "10px", fontWeight: 700 }}>{auditResult?.metrics.inp || "145ms"}</td>
                <td style={{ padding: "10px" }}><span className="pt-badge-good">🟢 Good</span></td>
              </tr>
              <tr>
                <td style={{ padding: "10px", fontWeight: 600 }}>CLS</td>
                <td style={{ padding: "10px" }}>{auditResult?.baseline_comparison.cls || "0.03"}</td>
                <td style={{ padding: "10px", fontWeight: 700 }}>{auditResult?.metrics.cls || "0.04"}</td>
                <td style={{ padding: "10px" }}><span className="pt-badge-good">🟢 Good</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* ------------------ TAB 11: PERFORMANCE BUDGETS ------------------ */}
      {activeTab === "budgets" && (
        <div className="pt-glass-card" style={{ padding: "24px" }}>
          <h2 style={{ margin: "0 0 16px 0", fontSize: "18px", fontWeight: 700, color: "#0f172a", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span>🛡️ Performance Budgets Validation</span>
            <span className={auditResult?.budgets.overall_pass ? "pt-badge-good" : "pt-badge-poor"}>
              {auditResult?.budgets.overall_pass ? "ALL BUDGETS PASSED ✅" : "BUDGET EXCEEDED ❌"}
            </span>
          </h2>

          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
            <thead>
              <tr style={{ background: "#f8fafc", textAlign: "left", color: "#475569" }}>
                <th style={{ padding: "10px" }}>Metric</th>
                <th style={{ padding: "10px" }}>Budget Target Limit</th>
                <th style={{ padding: "10px" }}>Actual Value</th>
                <th style={{ padding: "10px" }}>Result Status</th>
              </tr>
            </thead>
            <tbody>
              {(auditResult?.budgets.rules || [
                { metric: "Performance Score", target: "≥ 90", actual: "92", pass: true },
                { metric: "LCP", target: "< 2.5s", actual: "1.8s", pass: true },
                { metric: "INP", target: "< 200ms", actual: "145ms", pass: true },
                { metric: "CLS", target: "< 0.10", actual: "0.04", pass: true },
                { metric: "Total JS Size", target: "< 1.5 MB", actual: "1.9 MB", pass: false }
              ]).map((b, idx) => (
                <tr key={idx} style={{ borderBottom: "1px solid #f1f5f9" }}>
                  <td style={{ padding: "10px", fontWeight: 600 }}>{b.metric}</td>
                  <td style={{ padding: "10px", color: "#64748b" }}>{b.target}</td>
                  <td style={{ padding: "10px", fontWeight: 700 }}>{b.actual}</td>
                  <td style={{ padding: "10px" }}>
                    {b.pass ? (
                      <span className="pt-badge-good">✅ PASS</span>
                    ) : (
                      <span className="pt-badge-poor">❌ FAIL</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ------------------ TAB 12: AI PERFORMANCE ANALYSIS ------------------ */}
      {activeTab === "ai" && (
        <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
          {/* Score Improvement Plan */}
          <div className="pt-glass-card" style={{ padding: "24px", background: "#ffffff", border: "1px solid #e2e8f0" }}>
            <h2 style={{ margin: "0 0 12px 0", fontSize: "18px", fontWeight: 700, color: "#6b21a8", display: "flex", alignItems: "center", gap: "8px" }}>
              <span>🚀 AI Performance Improvement Plan</span>
            </h2>

            <div style={{ display: "flex", gap: "24px", marginBottom: "20px" }}>
              <div style={{ padding: "14px 24px", background: "#ffffff", borderRadius: "10px", border: "1px solid #e9d5ff", textAlign: "center" }}>
                <div style={{ fontSize: "12px", color: "#64748b" }}>Current Score</div>
                <div style={{ fontSize: "28px", fontWeight: 900, color: "#FD6101" }}>{auditResult?.improvement_plan.current_score || 68}</div>
              </div>

              <div style={{ padding: "14px 24px", background: "#ffffff", borderRadius: "10px", border: "1px solid #e9d5ff", textAlign: "center" }}>
                <div style={{ fontSize: "12px", color: "#64748b" }}>Estimated Potential Score</div>
                <div style={{ fontSize: "28px", fontWeight: 900, color: "#16a34a" }}>{auditResult?.improvement_plan.potential_score || "91+"}</div>
              </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
              {(auditResult?.improvement_plan.priorities || [
                { priority: 1, title: "Reduce LCP (Largest Contentful Paint)", impact: "HIGH", recommendation: "Optimize hero image and preload the LCP resource." },
                { priority: 2, title: "Reduce JavaScript execution", impact: "HIGH", recommendation: "Remove unused JavaScript and defer non-critical scripts." },
                { priority: 3, title: "Reduce render-blocking resources", impact: "MEDIUM", recommendation: "Defer non-critical CSS/JS." }
              ]).map((p, idx) => (
                <div key={idx} style={{ padding: "14px", background: "#ffffff", borderRadius: "10px", border: "1px solid #f1f5f9" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ fontSize: "14px", fontWeight: 700, color: "#0f172a" }}>
                      Priority {p.priority}: {p.title}
                    </div>
                    <span className="pt-badge-warn">Impact: {p.impact}</span>
                  </div>
                  <div style={{ fontSize: "13px", color: "#475569", marginTop: "6px" }}>
                    Recommended action: {p.recommendation}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Ask Qintra Interactive Chat */}
          <div className="pt-glass-card" style={{ padding: "24px" }}>
            <h3 style={{ margin: "0 0 12px 0", fontSize: "16px", fontWeight: 700, color: "#0f172a" }}>
              🤖 Ask Qintra Performance Copilot
            </h3>

            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginBottom: "16px" }}>
              {[
                "Why is my LCP high?",
                "Why did my score decrease?",
                "Which resource is causing the problem?",
                "What should developers fix first?",
                "Compare this with the previous run."
              ].map((promptText) => (
                <button
                  key={promptText}
                  onClick={() => {
                    setAiQuestion(promptText);
                    handleAskAi(promptText);
                  }}
                  style={{ background: "#f1f5f9", border: "1px solid #cbd5e1", borderRadius: "20px", padding: "6px 14px", fontSize: "12px", color: "#334155", cursor: "pointer" }}
                >
                  {promptText}
                </button>
              ))}
            </div>

            <div style={{ display: "flex", gap: "10px", marginBottom: "16px" }}>
              <input
                type="text"
                className="pt-input"
                value={aiQuestion}
                onChange={(e) => setAiQuestion(e.target.value)}
                placeholder="Ask Qintra anything about your performance score..."
              />
              <button className="pt-btn-primary" onClick={() => handleAskAi()} disabled={isAiLoading}>
                {isAiLoading ? "Analyzing..." : "Ask Qintra"}
              </button>
            </div>

            {aiAnswer && (
              <div style={{ padding: "16px", background: "#f8fafc", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
                <div style={{ fontSize: "13px", fontWeight: 700, color: "#FD6101", marginBottom: "6px" }}>
                  Qintra Response:
                </div>
                <pre style={{ whiteSpace: "pre-wrap", fontFamily: "inherit", fontSize: "13px", color: "#334155", margin: 0 }}>
                  {aiAnswer.answer}
                </pre>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ------------------ TAB 13: SCORE HISTORY ------------------ */}
      {activeTab === "history" && (
        <div className="pt-glass-card" style={{ padding: "24px" }}>
          <h2 style={{ margin: "0 0 16px 0", fontSize: "18px", fontWeight: 700, color: "#0f172a" }}>
            📉 Performance Score History & Trend
          </h2>

          <div style={{ display: "flex", gap: "12px", marginBottom: "20px" }}>
            {historyList.map((h, idx) => (
              <div key={idx} style={{ flex: 1, padding: "12px", background: "#f8fafc", borderRadius: "8px", border: "1px solid #e2e8f0", textAlign: "center" }}>
                <div style={{ fontSize: "11px", color: "#64748b" }}>{h.name}</div>
                <div style={{ fontSize: "20px", fontWeight: 800, color: "#FD6101", margin: "4px 0" }}>{h.score}</div>
                <div style={{ fontSize: "11px", color: "#94a3b8" }}>{h.created_at}</div>
              </div>
            ))}
          </div>

          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
            <thead>
              <tr style={{ background: "#f8fafc", textAlign: "left", color: "#475569" }}>
                <th style={{ padding: "10px" }}>Audit ID</th>
                <th style={{ padding: "10px" }}>Name</th>
                <th style={{ padding: "10px" }}>Score</th>
                <th style={{ padding: "10px" }}>LCP</th>
                <th style={{ padding: "10px" }}>INP</th>
                <th style={{ padding: "10px" }}>Timestamp</th>
              </tr>
            </thead>
            <tbody>
              {historyList.map((h, idx) => (
                <tr key={idx} style={{ borderBottom: "1px solid #f1f5f9" }}>
                  <td style={{ padding: "10px", fontWeight: 600, fontFamily: "monospace" }}>{h.audit_id}</td>
                  <td style={{ padding: "10px" }}>{h.name}</td>
                  <td style={{ padding: "10px", fontWeight: 700, color: getScoreColor(h.score).main }}>{h.score}</td>
                  <td style={{ padding: "10px" }}>{h.lcp}</td>
                  <td style={{ padding: "10px" }}>{h.inp}</td>
                  <td style={{ padding: "10px", color: "#64748b" }}>{h.created_at}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ------------------ TAB 14: EXECUTIVE REPORT ------------------ */}
      {activeTab === "report" && (
        <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
          {/* Executive Export Header */}
          <div className="pt-glass-card" style={{ padding: "28px", background: "#002247", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "16px" }}>
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "6px" }}>
                <span className="pt-badge-good" style={{ background: "#10b981", color: "#fff", border: "none" }}>CERTIFIED: PERFORMANCE AUDITED ✅</span>
                <span style={{ fontSize: "12px", color: "#c4b5fd" }}>Lighthouse v{auditResult?.lighthouse_version || "13.4.1"}</span>
              </div>
              <h2 style={{ margin: 0, fontSize: "24px", fontWeight: 800, color: "#fff" }}>
                Executive Performance & Core Web Vitals Audit Report
              </h2>
              <div style={{ fontSize: "13px", color: "#94a3b8", marginTop: "4px" }}>
                Target URL: <strong style={{ color: "#e2e8f0" }}>{form.target_url}</strong> | Device: {form.device} | Profile: {form.network_profile}
              </div>
            </div>

            {/* Action Bar Buttons */}
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              {auditResult?.report_urls?.html_report_url ? (
                <a
                  href={`${API_BASE}${auditResult.report_urls.html_report_url}`}
                  target="_blank"
                  rel="noreferrer"
                  className="pt-btn-primary"
                  style={{ textDecoration: "none", display: "inline-flex", alignItems: "center", gap: "6px" }}
                >
                  📄 Open HTML Report
                </a>
              ) : (
                <button className="pt-btn-primary" onClick={() => window.print()}>
                  🖨️ Export PDF / Print
                </button>
              )}
              {auditResult?.report_urls?.json_report_url && (
                <a
                  href={`${API_BASE}${auditResult.report_urls.json_report_url}`}
                  target="_blank"
                  rel="noreferrer"
                  style={{ padding: "8px 16px", borderRadius: "10px", background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.2)", color: "#fff", textDecoration: "none", fontSize: "13px", fontWeight: 600 }}
                >
                  { "{ }" } JSON Data
                </a>
              )}
            </div>
          </div>

          {/* Performance Summary Grid */}
          <div style={{ display: "grid", gridTemplateColumns: "280px 1fr", gap: "24px" }}>
            {/* Score Box */}
            <div className="pt-glass-card" style={{ padding: "28px", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
              <div style={{ fontSize: "12px", fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "1px", marginBottom: "12px" }}>
                Google Lighthouse Score
              </div>
              <div style={{ width: "120px", height: "120px", borderRadius: "50%", background: currentScoreInfo.bg, border: `4px solid ${currentScoreInfo.main}`, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                <span style={{ fontSize: "38px", fontWeight: 900, color: currentScoreInfo.main, lineHeight: 1 }}>{auditResult ? auditResult.score : 92}</span>
                <span style={{ fontSize: "11px", fontWeight: 700, color: currentScoreInfo.main }}>{currentScoreInfo.label}</span>
              </div>
              <div style={{ fontSize: "12px", color: "#64748b", marginTop: "14px" }}>
                Evaluated against Google Web Vitals Standard
              </div>
            </div>

            {/* Core Web Vitals Summary Table */}
            <div className="pt-glass-card" style={{ padding: "24px" }}>
              <h3 style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: 700, color: "#0f172a" }}>
                ⚡ Core Web Vitals Key Metrics
              </h3>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "16px" }}>
                <div style={{ padding: "16px", background: "#f8fafc", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
                  <div style={{ fontSize: "12px", color: "#64748b" }}>LCP (Largest Contentful Paint)</div>
                  <div style={{ fontSize: "24px", fontWeight: 800, color: "#FD6101", marginTop: "4px" }}>
                    {auditResult?.metrics.lcp || "1.8s"}
                  </div>
                  <div style={{ fontSize: "11px", color: "#16a34a", marginTop: "4px", fontWeight: 600 }}>Target: &lt; 2.5s (Good)</div>
                </div>

                <div style={{ padding: "16px", background: "#f8fafc", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
                  <div style={{ fontSize: "12px", color: "#64748b" }}>INP (Interaction to Next Paint)</div>
                  <div style={{ fontSize: "24px", fontWeight: 800, color: auditResult?.metrics.inp ? "#FD6101" : "#64748b", marginTop: "4px" }}>
                    {auditResult?.metrics.inp || "N/A (Lab Audit)"}
                  </div>
                  <div style={{ fontSize: "11px", color: "#64748b", marginTop: "4px", fontWeight: 600 }}>Field metric (N/A in Lab)</div>
                </div>

                <div style={{ padding: "16px", background: "#f8fafc", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
                  <div style={{ fontSize: "12px", color: "#64748b" }}>CLS (Cumulative Layout Shift)</div>
                  <div style={{ fontSize: "24px", fontWeight: 800, color: "#FD6101", marginTop: "4px" }}>
                    {auditResult?.metrics.cls || "0.04"}
                  </div>
                  <div style={{ fontSize: "11px", color: "#16a34a", marginTop: "4px", fontWeight: 600 }}>Target: &lt; 0.10 (Good)</div>
                </div>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "16px", marginTop: "16px" }}>
                <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px", border: "1px solid #f1f5f9" }}>
                  <div style={{ fontSize: "11px", color: "#64748b" }}>First Contentful Paint</div>
                  <div style={{ fontSize: "16px", fontWeight: 700, color: "#0f172a" }}>{auditResult?.metrics.fcp || "1.2s"}</div>
                </div>
                <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px", border: "1px solid #f1f5f9" }}>
                  <div style={{ fontSize: "11px", color: "#64748b" }}>Total Blocking Time</div>
                  <div style={{ fontSize: "16px", fontWeight: 700, color: "#0f172a" }}>{auditResult?.metrics.tbt || "150ms"}</div>
                </div>
                <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "8px", border: "1px solid #f1f5f9" }}>
                  <div style={{ fontSize: "11px", color: "#64748b" }}>Speed Index</div>
                  <div style={{ fontSize: "16px", fontWeight: 700, color: "#0f172a" }}>{auditResult?.metrics.speed_index || "2.1s"}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Remediation Action Plan */}
          <div className="pt-glass-card" style={{ padding: "24px" }}>
            <h3 style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: 700, color: "#0f172a" }}>
              🛠️ Executive Fix Action Plan
            </h3>
            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              {(auditResult?.opportunities || []).slice(0, 4).map((opp, idx) => (
                <div key={idx} style={{ padding: "14px", background: "#f8fafc", borderRadius: "10px", border: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div>
                    <div style={{ fontSize: "14px", fontWeight: 700, color: "#0f172a" }}>{opp.title}</div>
                    <div style={{ fontSize: "12px", color: "#64748b", marginTop: "2px" }}>{opp.problem}</div>
                  </div>
                  <span className={opp.severity === "CRITICAL" ? "pt-badge-poor" : "pt-badge-warn"}>
                    Savings: {opp.savings}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Opportunity Detail Modal */}
      {selectedOpportunity && (
        <div className="pt-modal-overlay" onClick={() => setSelectedOpportunity(null)}>
          <div className="pt-glass-card" style={{ width: "600px", padding: "28px" }} onClick={(e) => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
              <h3 style={{ margin: 0, fontSize: "18px", fontWeight: 700, color: "#0f172a" }}>
                {selectedOpportunity.title}
              </h3>
              <button onClick={() => setSelectedOpportunity(null)} style={{ background: "none", border: "none", fontSize: "18px", cursor: "pointer" }}>✕</button>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "12px", fontSize: "13px" }}>
              <div><strong>Problem:</strong> {selectedOpportunity.problem}</div>
              <div><strong>Why it matters:</strong> {selectedOpportunity.why_matters}</div>
              <div>
                <strong>Affected Resources:</strong>
                <ul style={{ margin: "4px 0", paddingLeft: "20px" }}>
                  {(selectedOpportunity.affected || []).map((res, i) => <li key={i}>{res}</li>)}
                </ul>
              </div>
              <div><strong>Recommended Solution:</strong> {selectedOpportunity.fix}</div>
              {selectedOpportunity.code_snippet && (
                <div style={{ background: "#0f172a", color: "#f8fafc", padding: "12px", borderRadius: "8px", fontFamily: "monospace", fontSize: "12px" }}>
                  {selectedOpportunity.code_snippet}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

